import * as React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'

import { cn } from '@/common/utils/utils'
import { X } from 'lucide-react'
import { Button } from './button'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

type PopoverContentProps = React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    mobileAnimate?: boolean
}

const PopoverContent = React.forwardRef<React.ElementRef<typeof PopoverPrimitive.Content>, PopoverContentProps>(
    ({ className, align = 'center', sideOffset, mobileAnimate = false, ...props }, ref) => {
        const mobileOffsetClass = mobileAnimate ? '-translate-y-[60px] sm:translate-y-0' : ''

        return (
            <PopoverPrimitive.Portal>
                <div>
                    {mobileAnimate && (
                        <PopoverPrimitive.Close asChild>
                            <div className="fixed inset-0 z-40 sm:hidden bg-[rgba(34,58,50,0.7)]" />
                        </PopoverPrimitive.Close>
                    )}
                    <PopoverPrimitive.Content
                        ref={ref}
                        align={align}
                        sideOffset={sideOffset}
                        className={cn(
                            'md:mt-5 z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none pointer-events-auto',
                            mobileAnimate &&
                                'animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-slide-out-to-top-2 data-[state=open]:animate-slide-in-from-top-2 data-[side=left]:animate-slide-in-from-right-2 data-[side=right]:animate-slide-in-from-left-2 data-[side=top]:animate-slide-in-from-bottom-2 md:animate-none md:data-[state=closed]:animate-none md:data-[state=open]:animate-none md:data-[side=left]:animate-none md:data-[side=right]:animate-none md:data-[side=top]:animate-none',
                            mobileOffsetClass,
                            className,
                        )}
                        side="bottom"
                        {...props}
                    >
                        {mobileAnimate && (
                            <div className="self-stretch p-2 inline-flex justify-end items-center gap-2.5 sm:hidden">
                                <PopoverPrimitive.Close asChild>
                                    <Button
                                        variant="ghost"
                                        aria-label="Close"
                                        className="w-6 h-6 relative overflow-hidden border-0 p-0"
                                    >
                                        <X className="text-brand-primary-forest" />
                                    </Button>
                                </PopoverPrimitive.Close>
                            </div>
                        )}

                        {props.children}
                    </PopoverPrimitive.Content>
                </div>
            </PopoverPrimitive.Portal>
        )
    },
)

PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverContent }
